import { types, actions } from './requests'
export const CREATECONTRACT_TYPES = {
    ...types('CREATECONTRACT'),
}
export const CREATECONTRACT_ACTIONS = {
    ...actions('CREATECONTRACT'),
}
